import type React from "react";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { ChannelForm } from "./ChannelForm";

interface CreateChannelDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const CreateChannelDialog: React.FC<CreateChannelDialogProps> = ({
	open,
	onOpenChange,
}) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>チャンネルを作成</DialogTitle>
				</DialogHeader>
				<ChannelForm onSuccess={() => onOpenChange(false)} />
			</DialogContent>
		</Dialog>
	);
};
